// extracted by mini-css-extract-plugin
module.exports = {"block":"Aside_block__1Q53X","timeWrap":"Aside_timeWrap__3vUD7"};